import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Loader } from 'belle-js'

const File = (props) => {
  const {
    file,
    removeFile,
    showPreview,
    canRemoveFile,
    uploading,
    uploaded,
  } = props

  const fileClasses = classnames(
    'File',
    {
      uploading: uploading && !uploaded,
      uploaded
    }
  )

  return (
    <li className={fileClasses}>
      {canRemoveFile && !uploaded && !uploading && (
        <button className="deleteButton" onClick={removeFile} type="button">
          &times;
        </button>
      )}

      {showPreview ? (
        <img src={file.preview} alt="File Preview" className="preview" />
      ) : (
        <p className="filename">
          {file.name}
        </p>
      )}

      {uploading && !uploaded && (
        <div className="loader">
          <Loader />
        </div>
      )}
    </li>
  )
}

File.defaultProps = {
  canRemoveFile: false,
  showPreview: false,
  uploading: false,
  uploaded: false
}

File.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string,
    preview: PropTypes.string
  }).isRequired,
  removeFile: PropTypes.func.isRequired,
  canRemoveFile: PropTypes.bool,
  showPreview: PropTypes.bool,
  uploading: PropTypes.bool,
  uploaded: PropTypes.bool
}


export default File



// WEBPACK FOOTER //
// ./src/components/Shared/DocumentUploader/File.jsx